{
  "seriousBusiness": {
    "title": "Ernstes Geschäft",
    "subtitle": "Für Profis, die ernsthaftes Business machen, gibt es diese Buttons. Nutze sie mit Bedacht."
  },
  "addFboLabel": "FBO hinzufügen",
  "deleteFboLabel": "<u>Dieses</u> FBO löschen",
  "currentFbos": {
    "title": "Aktuelle FBOs",
    "subtitle": "Ändere das Textfeld, um den FBO-Namen anzupassen. Wähle im Dropdown eine andere Subscription (Feature-Zugang), um diese zu ändern."
  },
  "subscriptionLabel": "Abonnement",
  "subscriptions": {
    "standard": "Standard",
    "autostacking": "Auto-Stapeln",
    "autostackingWithEdit": "Autostacking mit Hangar/Vorfeld-Bearbeitung",
    "autostackingWithEditAndCopy": "Autostacking mit Hangar/Vorfeld bearbeiten & kopieren",
    "inactive": "Inaktiv"
  }
}
